import { Box, Typography } from "@material-ui/core";
import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";
import PersonIcon from "@mui/icons-material/Person";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import i18n from '../../../../i18n';

const config = {
    initialMessages: [
        createChatBotMessage(
            i18n.t('popover.atis.content')
        ),
    ],
    botName: "atentuBot",
    customStyles: {
        botMessageBox: {
            backgroundColor: "#FE7100",
        },
        chatButton: {
            backgroundColor: "#FE7100",
        },
    },
    customComponents: {
        header: () => (
            <Box
                style={{
                    padding: 10,
                    backgroundColor: "#5C02A0",
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                }}
            >
                <Typography style={{ color: "white", fontWeight: "bold" }}>
                    {i18n.t('popover.atis.title')}
                </Typography>
            </Box>
        ),
        botAvatar: () => (
            <Box style={{ width: 60, padding: 5 }}>
                <Box
                    style={{
                        display: "flex",
                        backgroundColor: "#FE7100",
                        height: 40,
                        width: 40,
                        borderRadius: 20,
                        placeContent: "center",
                        alignItems: "center",
                    }}
                >
                    <SmartToyIcon style={{ color: "white" }} />
                </Box>
            </Box>
        ),
        userAvatar: () => (
            <Box
                style={{
                    minWidth: 60,
                    padding: 5,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Box
                    style={{
                        display: "flex",
                        backgroundColor: "#5C02A0",
                        height: 40,
                        width: 40,
                        borderRadius: 20,
                        placeContent: "center",
                        alignItems: "center",
                    }}
                >
                    <PersonIcon style={{ color: "white" }} />
                </Box>
            </Box>
        ),
    },
};

export default config;
